import React from 'react';
import './AdhivWebsite.css';

const AdhivWebsite: React.FC = () => {
  return (
    <div className="adhiv-website">
      <iframe
        src="https://adhiv.com"
        className="adhiv-website-iframe"
        title="adhiv.com"
        allowFullScreen
      />
      <div className="adhiv-website-grain"></div>
    </div>
  );
};

export default AdhivWebsite;

